import { render, staticRenderFns } from "./LanguagesEdit.vue?vue&type=template&id=b7984b50&"
import script from "./LanguagesEdit.vue?vue&type=script&lang=js&"
export * from "./LanguagesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports